import { ensurePersistentStorage } from "./db/persistence.js";

ensurePersistentStorage().then(({ persisted }) => {
  console.log(
    "[Companion]",
    persisted
      ? "Persistent storage granted"
      : "Persistent storage denied — files may be evicted under storage pressure"
  );
});

if (navigator.serviceWorker) {
  navigator.serviceWorker
    .register("/service-worker.js", { scope: "/" })
    .then(() => navigator.serviceWorker.ready)
    .then(() => {
      console.log("[Companion]", "Service worker registered!");
      document.dispatchEvent(new CustomEvent("artemis:service-worker-ready"));
    })
    .catch((error) => {
      console.warn("[Companion]", "Service worker registration failed", error);
    });
}
